import { Injectable } from '@angular/core';
import { TypeBagsWeight, StatusBag } from '@app/enums';
import { PnrLookUpMapper } from '@app/mappers';
import { Segment } from '@app/models/cart/segment.model';
import { Passenger } from '@app/models/passenger.model';
import { Reservation } from '@app/models/reservation.model';
import { SeatMap } from '@app/models/seatMap.model';
import {
  ExtrasBagsAncillarieInt,
  LanguagesInt,
  PNRCollectionInt,
  PassportScanInfoInt,
  BoardingPassResponseInt
} from '@interfaces/';
import { TranslateService } from '@ngx-translate/core';
import {  BehaviorSubject } from "rxjs";
import {AdminService} from "@services/admin.service";

@Injectable({
  providedIn: 'root'
})
export class GlobalsService {
  language$ = new BehaviorSubject<string>('es_MX');
  disableBagsFlow$ = new BehaviorSubject<boolean>(false);
  languages: Array<LanguagesInt> =
    [
      {
        id: 'es-MX',
        text: 'Español'
      },
      {
        id: 'en-US',
        text: 'English'
      },
      {
        id: 'fr-FR',
        text: 'Français'
      },
      {
        id: 'du-NL',
        text: 'Nederlands'
      },
      {
        id: 'pt-PT',
        text: 'Português'
      },
      {
        id: 'ja-JP',
        text: '日本語'
      },
      {
        id: 'zh-CN',
        text: '中文'
      }
      ,
      {
        id: 'kr-KR',
        text: '한국어'
      }
    ];
  languageSelected: LanguagesInt = this.languages[0];
  pnrLookUpApi: PNRCollectionInt;
  pnrLookUp: Array<Reservation> = [];
  selectedTrip: Segment | null = null;
  seapMapInfoArray: Array<SeatMap> = [];
  passengerSelected: Passenger | null = null;
  passportInfoToPnrLookUp: PassportScanInfoInt;

  reservation: Reservation | null = null;
  selectedSegment: Segment | null = null;
  ancillaries: ExtrasBagsAncillarieInt;
  reloadPnr:boolean;
  isMultiFlightsOpt= false;
  refreshPNR: boolean = false;

  constructor(
    private _traslateService: TranslateService,
    private _admin: AdminService
  ) { }

  //#region LookUp
  setPNRLookUpApi(pnrLookUpApi: PNRCollectionInt) {
    if (pnrLookUpApi || Object.keys(pnrLookUpApi).length > 0) {
      this.pnrLookUpApi = pnrLookUpApi;
      sessionStorage.setItem('pnrLookUpApiOld', JSON.stringify(pnrLookUpApi));
    }
  }

  setPNRLookUp(reservation: Array<Reservation>): void {
    if (reservation || Object.keys(reservation).length > 0) {
      this.pnrLookUp = reservation;
      sessionStorage.setItem('pnrLookUpOld', JSON.stringify(reservation));
    }
  }

  setPNRLookupAWSInt(obj) {
    sessionStorage.setItem('PNRLookupAWSInt', JSON.stringify(obj));
  }

  setViewDocumentsInt(res) {
    sessionStorage.setItem('viewDocuments', JSON.stringify(res));
  }

  getViewDocumentsInt() {
    const ViewDocumentsInt = sessionStorage.getItem('ViewDocumentsInt');
    return ViewDocumentsInt ? JSON.parse(ViewDocumentsInt) : {};
  }


  getPNRLookupAWSInt() {
    const PNRLookupAWSInt = sessionStorage.getItem('PNRLookupAWSInt');
    return PNRLookupAWSInt ? JSON.parse(PNRLookupAWSInt) : {};
  }

  getPNRLookup(): Array<Reservation> {
    const {Location}= this._admin.admin;
    if (this.pnrLookUp?.length > 0) {
      return this.pnrLookUp;
    } else {
      const sessionPNR = sessionStorage.getItem('pnrLookUpApiOld');
      if (sessionPNR) {
        this.pnrLookUp = PnrLookUpMapper.pnrBuild(JSON.parse(sessionPNR),Location);
        return this.pnrLookUp;
      } else {
        return [];
      }
    }
  }

  setReservation(reservation: Reservation): void {
    if (reservation || Object?.keys(reservation).length > 0) {
      this.reservation = reservation;
      sessionStorage.setItem('reservationOld', JSON.stringify(reservation));
    }
  }

  getReservation(): Reservation {
    if (this.reservation) { return this.reservation; }
    let sessionReservation = sessionStorage.getItem('reservationOld');
    this.reservation = new Reservation();
    if (sessionReservation) {
      sessionReservation = JSON.parse(sessionReservation);
      Object.assign(this.reservation, sessionReservation);
    }
    return this.reservation;
  }

  setSelectedTrip(segment: Segment): void {
    if (segment) {
      this.selectedTrip = segment;
      sessionStorage.setItem('selectedTripOld', JSON.stringify(segment));
    }
  }

  getSelectedTrip(): Segment {
    if (this.selectedTrip) {
      return this.selectedTrip;
    } else {
      let segmentSelectedTrip = sessionStorage.getItem('selectedTripOld') || '';
      this.selectedTrip = new Segment();

      if (segmentSelectedTrip) {
        segmentSelectedTrip = JSON.parse(segmentSelectedTrip);
        Object.assign(this.selectedTrip, segmentSelectedTrip)
      }

      return this.selectedTrip;
    }
  }

  setDataPassportInfoToPnrLookUp(passportInfo: PassportScanInfoInt) {
    this.passportInfoToPnrLookUp = passportInfo;
  }

  getDataPassportInfoToPnrLookUp() {
    return this.passportInfoToPnrLookUp;
  }

  clearDataPassportInfoToPnrLookUp() {
    this.passportInfoToPnrLookUp = undefined;
  }

  //#endregion LookUp
  setPassenger(passenger: Passenger): void {
    if (passenger || Object.keys(passenger).length > 0) {
      let passengers = this.getPassengers();
      let passenger_ = passengers.find(x => x.id == passenger.id);
      passenger_ = passenger;
      this.reservation.passengers = passengers;
      this.setReservation(this.reservation);
    }
  }

  getPassengers(): Array<Passenger> {
    if (this.reservation?.passengers?.length > 0) {
      return this.reservation.passengers;
    }
    let sessionPassengerTrip = this.getReservation().passengers;
    sessionPassengerTrip = sessionPassengerTrip || [];
    let passengersTrip = [];
    for (let passenger of sessionPassengerTrip) {
      let passenger_ = new Passenger();
      Object.assign(passenger_, passenger);
      passengersTrip.push(passenger_);
    }
    return passengersTrip;
  }

  //set boardingPass
  setBoardingPassPrinter(boardingPassPrinter: BoardingPassResponseInt) {
    boardingPassPrinter.value =  boardingPassPrinter.value.filter(x=> x); 
    sessionStorage.setItem('boardingPassPrinter', JSON.stringify(boardingPassPrinter));
  }

  getBoardingPassPrinter(): BoardingPassResponseInt { 
    const boardingPass = sessionStorage.getItem('boardingPassPrinter');
    return boardingPass ? JSON.parse(boardingPass) : undefined;
  }

  setOverbookingFlow(yesNo) {
    sessionStorage.setItem('overBookingFlow', JSON.stringify(yesNo));
  }

  getOverbookingFlow() {
    const overBookingFlow = sessionStorage.getItem('overBookingFlow');

    return overBookingFlow ? JSON.parse(overBookingFlow) : false;
  }

  setCurrentBagTag(obj) {
    sessionStorage.setItem('currentBagTag', JSON.stringify(obj));
  }

  getCurrentBagTag() {
    const currentBagTag = sessionStorage.getItem('currentBagTag');

    return currentBagTag ? JSON.parse(currentBagTag) : {};
  }

  clearPNRLookupAWSInt(): void {
    sessionStorage.removeItem('PNRLookupAWSInt');
  }
  clearBoardingPassPrinter(): void {
    sessionStorage.removeItem('boardingPassPrinter');
  }
  clearPNRLookUpApiOld(): void {
    sessionStorage.removeItem('pnrLookUpApiOld');
  }
  clearAncillaries(): void {
    this.ancillaries = null;
    sessionStorage.removeItem('ancillaries');
  }
  clearPNRLookUp(): void {
    this.pnrLookUp = null;
    sessionStorage.removeItem('pnrLookUpOld');
  }
  clearSelectTrip(): void {
    this.selectedTrip = null;
    sessionStorage.removeItem('selectedTripOld');
  }
  clearReservation(): void {
    this.reservation = null;
    sessionStorage.removeItem('reservationOld');
  }


  clearAll() {
    this.clearPNRLookupAWSInt();
    this.clearBoardingPassPrinter();
    this.clearPNRLookUpApiOld();
    this.clearAncillaries();
    this.clearPNRLookUp();
    this.clearSelectTrip();
    this.clearReservation();
    
    this.clearDataPassportInfoToPnrLookUp();
    this.language$.next(this._admin.admin?.DEFAULT_LANGUAGE);
    this._traslateService.use(this._admin.admin?.DEFAULT_LANGUAGE)

  }

  abbreviateString(string, maxLength) {
    if (string == null || maxLength == null) {
      return string;
    }
    var newString = string;
    if (newString.length >= maxLength) {
      newString = newString.substring(0, maxLength - 2);
      newString += '..';
    }
    return newString;
  }

  separateIntoGroups(list, sizeOfGroup) {
    if (list == null || sizeOfGroup == null) {
      throw "Null Not Allowed";
    }
    var groups = [];
    var groupIndex = 0;
    for (var index = 0; index < list.length; index++) {
      var passenger = list[index];
      if (groups[groupIndex] == null) {
       
        groups[groupIndex] = [];
      }
     
      groups[groupIndex].push(passenger);

      if (groups[groupIndex].length == sizeOfGroup) {
        groupIndex++;
      }
    }
    return groups;
  }

  hasPremierBags() {
    const passengers: Passenger[] = this.getPassengers();
    const reservation = this.getReservation();
    let existsPremierBags = undefined;
    if (reservation?.flightSummary?.fareFamily === 'PREMIER') {
      existsPremierBags = passengers.find(x => x.bagStack.find(y => y.typeBagWeight == TypeBagsWeight._32KG && !y.used));
    }
    return existsPremierBags ? true : false;
  }

  buildReprintBoardingPassInput(passengers:Passenger[]) {
    const passengerIds = passengers?.map(x => x.id).filter(id => id != null);
    return {
      pnrCode: this.reservation.pnr,
      language: this._traslateService.currentLang,
      legCode: this.reservation.flightSummary.legCode,
      passengerIds: passengerIds
    };
  }

  //#region Cart

  setAncillaries(ancillaries: ExtrasBagsAncillarieInt) {
    this.ancillaries = ancillaries;
    this.setTotalAncillariesPassengers(ancillaries);
    sessionStorage.setItem('ancillaries', JSON.stringify(ancillaries));
  }

  getAncillaries(): ExtrasBagsAncillarieInt {
    if (this.ancillaries) { return this.ancillaries; }
    let ancillariesStorage = sessionStorage.getItem('ancillaries');
    this.ancillaries = {}
    if (ancillariesStorage) {
      ancillariesStorage = JSON.parse(ancillariesStorage);
      Object.assign(this.ancillaries, ancillariesStorage);
    }
    return this.ancillaries;
  }

  setTotalAncillariesPassengers(ancillaries: ExtrasBagsAncillarieInt) {
    if(ancillaries.extraBags?.length > 0){
      const lengthExtraBags = ancillaries.extraBags.length
     
      this.getPassengers().map(x=> x.totalBags = lengthExtraBags || 7)
    }
  }

  //#endregion Cart

  setSeatMapInfo(seat) {

    if (seat) {
      sessionStorage.setItem('SeatMapInfoOld', JSON.stringify(seat));
    }

  }

  getSeatMapInfo() {
    let SeatMapSession = sessionStorage.getItem('SeatMapInfoOld');
    SeatMapSession = SeatMapSession ? JSON.parse(SeatMapSession) : []
    this.seapMapInfoArray = []
    for (let seat of SeatMapSession) {
      let seat_ = new SeatMap();
      Object.assign(seat_, seat)
      this.seapMapInfoArray.push(seat_);
    }
    return this.seapMapInfoArray;
  }

  setSeatMapSegment(obj) {
    sessionStorage.setItem('SeatMapOld', JSON.stringify(obj));
  }

  getSeatMapSegmet() {
    const SeatMap = sessionStorage.getItem('SeatMapOld');
    return SeatMap ? JSON.parse(SeatMap) : {};
  }

  clearSesionStorage(){
    sessionStorage.clear();
    localStorage.clear();
  }

  set isMultiFlights (isMultiple: boolean) {
    this.isMultiFlightsOpt = isMultiple
  }

  get isMultiFlights(): boolean {
    return this.isMultiFlightsOpt
  }

}
